/* ==========================================
   SHARED FUZZY SEARCH VOCABULARY
========================================== */

/*
  Correctly spelled terms that the fuzzy
  search engine is allowed to match toward.

  This vocabulary was generated from current
  Shopify titles using:

  - minimum 5 characters
  - minimum 2 distinct titles
  - singular/plural canonicalization
  - stop-word filtering

  SEARCH_TERM_GROUPS are NOT duplicated here.
  Eligible terms from those groups will be
  merged automatically at runtime.

  Technical model-family identifiers have
  been excluded.
*/

window.NXTSearchVocabulary = [

  "adalet",
  "aircraft",
  "amber",
  "angled",
  "arrestor",
  "assembly",
  "barrel",
  "bemis",
  "bigger",
  "black",
  "block",
  "bottom",
  "cable",
  "center",
  "circular",
  "clear",
  "clipsal",
  "coated",
  "compatible",
  "connector",
  "contact",
  "device",
  "distribution",
  "drain",
  "electrical",
  "explosion",
  "female",
  "fitting",
  "flame",
  "fully",
  "gewiss",
  "gland",
  "grace",
  "green",
  "ground",
  "hellermann",
  "hellermanntyton",
  "horizontal",
  "illuminated",
  "incandescent",
  "industrial",
  "inline",
  "interlock",
  "interlocked",
  "isolator",
  "italy",
  "joint",
  "larger",
  "lighting",
  "listed",
  "maintained",
  "modular",
  "momentary",
  "mount",
  "mounted",
  "mushroom",
  "outlet",
  "panel",
  "pilot",
  "power",
  "powerlock",
  "proconect",
  "proof",
  "provision",
  "pushbutton",
  "range",
  "rotary",
  "safety",
  "shore",
  "short",
  "singapore",
  "socapex",
  "socket",
  "solution",
  "source",
  "stainless",
  "start",
  "steel",
  "straight",
  "surface",
  "switch",
  "switched",
  "syntax",
  "techno",
  "technology",
  "tyton",
  "valentini",
  "vertical",
  "waterproof",
  "white"

];